export type Pt = [number, number];
export type Level = {
  id: string; box: string; n: number;
  /** 정규화: 판 폭 = ASPECT, 높이 = 1, y 아래로 */
  candy: Pt;
  /** auto: 사탕이 radius 안에 들어오면 밧줄이 걸리는 고리(원작의 점선 원 고리). len 은 걸릴 때의 거리로 정해진다 */
  hooks: { p: Pt; len: number; auto?: true; radius?: number }[];
  omnom: Pt;
  stars: Pt[];
  bubbles?: Pt[];
  spikes?: { a: Pt; b: Pt }[];
  cushions?: { p: Pt; dir: 'n' | 'e' | 's' | 'w' }[];
  src?: { video: string; t: number; flags: string[]; warn?: string[] };
};
export type LevelFile = { version: 1; levels: Level[] };

/** 원작 세로 화면 비율(폭/높이). 영상 게임 영역 실측으로 보정. */
export const ASPECT = 2 / 3;
export const WORLD_H = 10; // m
export function toWorld(p: Pt): Pt { return [p[0] * WORLD_H, (1 - p[1]) * WORLD_H]; }
export function toNorm(p: Pt): Pt { return [p[0] / WORLD_H, 1 - p[1] / WORLD_H]; }

export function validateLevel(l: Level): string[] {
  const errs: string[] = [];
  if (!l.hooks?.length) errs.push('hooks');
  if (!l.candy || !l.omnom) errs.push('candy/omnom');
  if ((l.stars ?? []).length > 3) errs.push('stars');
  for (const h of l.hooks ?? []) {
    if (h.auto) continue;
    const d = Math.hypot(h.p[0] - l.candy[0], h.p[1] - l.candy[1]);
    if (h.len < d * 0.9) errs.push('rope-short');
  }
  if (!(l.hooks ?? []).some((h) => !h.auto)) errs.push('no-attached-rope');
  return errs;
}
